module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 8 16",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }